import { FC, memo } from "react";
import { Skeleton } from '@mui/material';
import { PatientProfileHeaderSkeleton } from "../../header/header.skeleton";
import { Box } from '@mui/system';

export const MainViewSkeleton: FC = memo(() => {
  return <>
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <PatientProfileHeaderSkeleton />
      <Box sx={{ height: '20px' }}></Box>
      {Array.from({ length: 5 }).map((_, index) => (
        <Skeleton key={index} variant="rounded" width={270} height={48} sx={{ margin: '0 auto 10px auto' }} />
      ))}
      <Box sx={{ flexDirection: 'row', display: 'flex', margin: '0 auto 10px auto' }}>
        <Skeleton variant="rounded" width={50} height={48}  />
        <Skeleton variant="rounded" width={210} height={48} sx={{ marginLeft: '10px' }} />
      </Box>
      {Array.from({ length: 2 }).map((_, index) => (
        <Skeleton key={index} variant="rounded" width={270} height={48} sx={{ margin: '0 auto 10px auto' }} />
      ))}
    </Box>
  </>
});